module.exports = __webpack_public_path__ + "img/SendOutlined.2f13cfba.svg";